import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { DocumentDtoKeysEnum } from '@zaoblako/shared/modules/document/enums/document-dto-keys.enum';
import { entityLikeSchema, entityLikeSchemaUuid } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { ClientCheckerKeysEnum } from '@zaoblako/shared/modules/client/enums/client-checker-keys.enum';
import { StorageBackendValidatorsEnum } from '@zaoblako/shared/modules/storage/enums/storage-backend-validators.enum';
import type { CompanyFindInterface } from '@zaoblako/shared/modules/client/dtos/company/find/company-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';

import * as yup from 'yup';

/** Credit/Debit exclusion create and update APIs request body - DTO signature */
export interface CreditDebitExclusionFormInterface {
  /** Debts with this amount value will be excluded */
  amount: number;
  /** Date until which payment is deferred */
  defermentGrantedUntil?: Date;
  /** Additional commentary for exclusion */
  commentary?: string;
  /** Debts for this company will be excluded */
  company: CompanyFindInterface;
  /** Debts for this counterparty will be excluded */
  contragent: ContragentFindInterface;
  /** File attached to exclusion */
  file?: FileFindInterface;
}

/** Credit/Debit exclusion create and update APIs request body - DTO schema */
export const CreditDebitExclusionFormDto = SerdeDtoClass.create<CreditDebitExclusionFormInterface>(DocumentDtoKeysEnum.CREDIT_DEBIT_EXCLUSION_FORM_DTO, {
  amount: {
    label: 'Сумма',
    serializer: yup.number(),
  },
  defermentGrantedUntil: {
    optional: true,
    label: 'Дата отсрочки',
    serializer: yup.date(),
  },
  commentary: {
    optional: true,
    label: 'Комментарий',
    serializer: yup.string(),
  },
  company: {
    label: 'Компания',
    serializer: entityLikeSchema,
    checkers: [ClientCheckerKeysEnum.COMPANY_ASSERT_EXISTS_BY_DTO],
  },
  contragent: {
    label: 'Контрагент',
    serializer: entityLikeSchema,
    checkers: [ClientCheckerKeysEnum.CONTRAGENT_ASSERT_EXISTS_BY_DTO],
  },
  file: {
    optional: true,
    label: 'Файл',
    serializer: entityLikeSchemaUuid,
    checkers: [StorageBackendValidatorsEnum.FILE_ASSERT_EXISTS_BY_DTO],
  },
});
